(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Mobile Submenu Toggle Function - Simple approach that doesn't break existing menu
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(initMobileDropdown, 100);
  });

  // Run again after page load to ensure menu is ready
  window.addEventListener('load', function() {
    setTimeout(initMobileDropdown, 200);
  });

  function initMobileDropdown() {
    // Only run on mobile
    if (window.innerWidth >= 990) return;
    
    const menuDrawer = document.querySelector('menu-drawer');
    if (!menuDrawer) return;

    // Observer to watch for menu changes
    const observer = new MutationObserver(function() {
      addDropdownBehavior();
    });

    observer.observe(menuDrawer, {
      childList: true,
      subtree: true
    });

    addDropdownBehavior();
  }

  function addDropdownBehavior() {
    const menuDrawer = document.querySelector('menu-drawer');
    if (!menuDrawer) return;

    // Find menu items that have child menus
    const menuItems = menuDrawer.querySelectorAll('.menu-drawer__menu > li');
    
    menuItems.forEach(li => {
      // Check if this item has a nested ul (submenu)
      const nestedMenu = li.querySelector(':scope > ul');
      
      if (nestedMenu && !li.classList.contains('dropdown-enabled')) {
        li.classList.add('dropdown-enabled');
        
        // Find the link or button in this li
        const trigger = li.querySelector(':scope > .menu-drawer__menu-item, :scope > a, :scope > button');
        
        if (trigger) {
          // Add arrow if not present
          if (!trigger.querySelector('.mobile-submenu-arrow')) {
            const arrow = document.createElement('span');
            arrow.className = 'mobile-submenu-arrow';
            arrow.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 6l4 4 4-4"/></svg>';
            trigger.appendChild(arrow);
            trigger.style.paddingRight = '50px';
            trigger.style.position = 'relative';
          }

          // Remove existing click handlers by cloning
          const newTrigger = trigger.cloneNode(true);
          trigger.parentNode.replaceChild(newTrigger, trigger);
          
          // Add new click handler
          newTrigger.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            const isOpen = li.classList.contains('submenu-open');
            const arrow = newTrigger.querySelector('.mobile-submenu-arrow');
            
            // Close all other submenus
            menuItems.forEach(otherLi => {
              if (otherLi !== li) {
                otherLi.classList.remove('submenu-open');
                const otherArrow = otherLi.querySelector('.mobile-submenu-arrow');
                if (otherArrow) otherArrow.classList.remove('active');
              }
            });
            
            // Toggle this submenu
            if (isOpen) {
              li.classList.remove('submenu-open');
              if (arrow) arrow.classList.remove('active');
            } else {
              li.classList.add('submenu-open');
              if (arrow) arrow.classList.add('active');
            }
          });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
